<div class="sc-zipcode-widget" [ngClass]="align" [class.border]="+border === 1" [ngSwitch]="currentStep">
  <ng-container *ngSwitchCase="steps.zip">
    <div class="sc-prefix" *ngIf="text1" [innerHTML]="text1 | safe"></div>
  </ng-container>
  <ng-container *ngSwitchCase="steps.phone">
    <div class="sc-prefix" *ngIf="text2" [innerHTML]="text2 | safe"></div>
  </ng-container>
  <ng-container *ngSwitchCase="steps.term">
    <div class="sc-prefix" *ngIf="text3" [innerHTML]="text3 | safe"></div>
  </ng-container>
  <form
    #formRef
    sc-form
    novalidate
    [formGroup]="form"
    (ngSubmit)="nextStep($event)">
    <div class="sc-wrap">
      <section *ngSwitchCase="steps.zip" class="zipcode-section">
        <sc-input
          formControlName="zip"
          placeholder="00-000"
          mask="00-000"
          inputmode="numeric"
          maxlength="6"
          [errorRef]="errorZip"
          (onupdate)="resetErrors()"
          [customErrors]="errors.zipcode"
        >
          <i><ng-container [ngTemplateOutlet]="iconLocation"></ng-container></i>
        </sc-input>
        <sc-error #errorZip [class.hidden]="!submitted"></sc-error>
      </section>
      <section *ngSwitchCase="steps.phone" class="phone-section">
        <sc-input
          formControlName="phone"
          placeholder="Podaj nr telefonu"
          inputmode="tel"
          [errorRef]="errorPhone"
          (onupdate)="resetErrors()"
          [customErrors]="errors.phone"
        >
          <i><ng-container [ngTemplateOutlet]="iconPhone"></ng-container></i>
        </sc-input>
        <sc-error #errorPhone [class.hidden]="!submitted"></sc-error>
      </section>
      <section *ngSwitchCase="steps.term" class="term-section">
        <sc-checkbox
          formControlName="term"
          [errorRef]="errorTerm"
          [customErrors]="errors.term"
        >
          <div class="label">
            <span>Akceptuję
              <a
                href="https://zatrzymajlicznik.pl/regulamin"
                target="_blank"
                rel="noopener noreferrer"
                title="Regulamin świadczenia usług"
              >regulamin</a>
            </span>
          </div>
        </sc-checkbox>
        <sc-error #errorTerm [class.hidden]="!submitted"></sc-error>
      </section>
    </div>
    <button sc-button type="submit" [class.last]="steps.term === currentStep">
      <ng-container *ngSwitchCase="steps.zip">
        <span>{{ button1 }}</span>
        <i><ng-container [ngTemplateOutlet]="iconArr"></ng-container></i>
      </ng-container>
      <ng-container *ngSwitchCase="steps.phone">
        <span>{{ button2 }}</span>
        <i><ng-container [ngTemplateOutlet]="iconArr"></ng-container></i>
      </ng-container>
      <ng-container *ngSwitchCase="steps.term">
        <span>{{ button3 }}</span>
        <i><ng-container [ngTemplateOutlet]="iconDone"></ng-container></i>
      </ng-container>
    </button>
  </form>
</div>

<ng-template #iconLocation>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:svgjs="http://svgjs.com/svgjs"
    version="1.1"
    width="512"
    height="512"
    x="0"
    y="0"
    viewBox="0 0 376 376"
    style="enable-background:new 0 0 512 512"
    xml:space="preserve"
    class=""
  >
    <g>
      <path
        xmlns="http://www.w3.org/2000/svg"
        style=""
        d="M316,136c0,23.36-6.24,45.2-17.12,64L188,368L77.12,200C66.24,181.2,60,159.36,60,136
          C60,65.28,117.28,8,188,8S316,65.28,316,136z
          M252,136c0-35.36-28.64-64-64-64s-64,28.64-64,64s28.64,64,64,64S252,171.36,252,136z"
        fill="#f7e9e1"
        data-original="#cce4ff"
        class=""
      />
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          style=""
          d="M70.44,204.408l110.88,168c1.488,2.24,3.992,3.592,6.68,3.592s5.192-1.352,6.68-3.592l111.128-168.4
              C317.712,183.432,324,159.912,324,136C324,61.008,262.992,0,188,0S52,61.008,52,136c0,23.912,6.288,47.432,18.192,68
              C70.272,204.144,70.352,204.28,70.44,204.408z
              M188,16c66.168,0,120,53.832,120,120c0,21.104-5.544,41.848-15.8,59.592L188,353.48
              L83.928,195.8C73.504,177.704,68,157.032,68,136C68,69.832,121.832,16,188,16z"
          fill="#e86c26"
          data-original="#007aff"
          class=""
        />
        <path
          style=""
          d="M188,208c39.704,0,72-32.304,72-72s-32.296-72-72-72s-72,32.304-72,72S148.296,208,188,208z
                M188,80
                c30.872,0,56,25.12,56,56s-25.128,56-56,56s-56-25.12-56-56S157.128,80,188,80z"
          fill="#e86c26"
          data-original="#007aff"
          class=""
        />
      </g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
    </g>
  </svg>
</ng-template>

<ng-template #iconPhone>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:svgjs="http://svgjs.com/svgjs"
    version="1.1"
    width="512"
    height="512"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    style="enable-background:new 0 0 512 512"
    xml:space="preserve"
    class=""
  >
    <g>
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M224,0H74.667C33.493,0,0,33.493,0,74.667v362.667C0,478.507,33.493,512,74.667,512H96    c5.888,0,10.667-4.779,10.667-10.667c0-5.888-4.779-10.667-10.667-10.667H74.667c-29.397,0-53.333-23.936-53.333-53.333V74.667    c0-29.397,23.936-53.333,53.333-53.333H224c29.397,0,53.333,23.936,53.333,53.333v106.667c0,5.888,4.779,10.667,10.667,10.667    s10.667-4.779,10.667-10.667V74.667C298.667,33.493,265.173,0,224,0z"
            fill="#e86c26"
            data-original="#000000"
            style=""
            class=""
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M288,85.333H10.667C4.779,85.333,0,90.112,0,96s4.779,10.667,10.667,10.667H288c5.888,0,10.667-4.779,10.667-10.667    S293.888,85.333,288,85.333z"
            fill="#e86c26"
            data-original="#000000"
            style=""
            class=""
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M192,384H10.667C4.779,384,0,388.779,0,394.667s4.779,10.667,10.667,10.667H192c5.888,0,10.667-4.779,10.667-10.667    S197.888,384,192,384z"
            fill="#e86c26"
            data-original="#000000"
            style=""
            class=""
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M181.333,42.667h-64c-5.888,0-10.667,4.779-10.667,10.667S111.445,64,117.333,64h64C187.221,64,192,59.221,192,53.333    S187.221,42.667,181.333,42.667z"
            fill="#e86c26"
            data-original="#000000"
            style=""
            class=""
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M224.427,42.667h-0.213c-5.888,0-10.56,4.779-10.56,10.667S218.539,64,224.427,64c5.888,0,10.667-4.779,10.667-10.667    S230.315,42.667,224.427,42.667z"
            fill="#e86c26"
            data-original="#000000"
            style=""
            class=""
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M481.493,282.347l-80.213-88.149c-15.872-15.872-41.728-15.893-57.749,0.128c-5.077,5.077-8.533,11.157-10.325,17.643    c-15.957-12.203-38.976-11.008-53.675,3.691c-5.056,5.077-8.512,11.157-10.347,17.621c-15.957-12.203-38.976-11.008-53.653,3.712    c-4.971,4.971-8.384,10.923-10.24,17.216l-37.803-37.803c-15.872-15.872-41.728-15.893-57.749,0.128    c-15.893,15.872-15.893,41.728,0,57.621l145.237,145.237l-86.144,13.525C145.557,436.245,128,456.469,128,480    c0,17.643,14.357,32,32,32h201.152c31.339,0,60.8-12.203,82.965-34.368l33.557-33.557C499.819,421.952,512,392.512,512,361.216    C512,331.989,501.163,303.979,481.493,282.347z M462.592,428.992l-33.557,33.557c-18.133,18.133-42.24,28.117-67.883,28.117H160    c-5.888,0-10.667-4.779-10.667-10.667c0-12.971,9.685-24.128,22.656-26.005l106.987-16.811c3.968-0.619,7.232-3.413,8.491-7.232    c1.237-3.797,0.235-8-2.603-10.837L124.8,259.051c-7.573-7.573-7.573-19.883,0.128-27.584c3.797-3.776,8.768-5.675,13.739-5.675    c4.971,0,9.941,1.899,13.739,5.696l106.731,106.731c4.16,4.16,10.923,4.16,15.083,0c2.069-2.091,3.115-4.821,3.115-7.552    c0-2.731-1.045-5.461-3.115-7.531l-43.584-43.584c-7.573-7.573-7.573-19.883,0.128-27.584c7.552-7.552,19.904-7.552,27.456,0    l43.584,43.584c4.16,4.16,10.923,4.16,15.083,0c2.069-2.091,3.115-4.821,3.115-7.552s-1.045-5.461-3.029-7.445l-22.251-22.251    c-7.573-7.573-7.573-19.883,0.128-27.584c7.552-7.552,19.904-7.552,27.456,0l22.251,22.251c0.021,0.021,0.021,0.021,0.021,0.021    l0.021,0.021c0.021,0.021,0.021,0.021,0.021,0.021c0.021,0.021,0.021,0.021,0.021,0.021h0.021c0.021,0,0.021,0.021,0.021,0.021    c4.181,3.947,10.773,3.883,14.869-0.213c4.16-4.16,4.16-10.923,0-15.083l-0.917-0.917c-3.669-3.669-5.696-8.555-5.696-13.739    c0-5.184,2.005-10.048,5.803-13.845c7.573-7.552,19.883-7.531,27.115-0.363l79.872,87.787    c16.064,17.685,24.939,40.597,24.939,64.512C490.667,386.816,480.704,410.88,462.592,428.992z"
            fill="#e86c26"
            data-original="#000000"
            style=""
            class=""
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
    </g>
  </svg>
</ng-template>

<ng-template #iconArr>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:svgjs="http://svgjs.com/svgjs"
    version="1.1"
    width="19"
    height="22"
    x="0"
    y="0"
    viewBox="0 0 511.993 511.993"
    style="enable-background:new 0 0 19 22"
    xml:space="preserve"
  >
    <g>
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M487.292,235.408H20.59c-11.372,0-20.59,9.224-20.59,20.59c0,11.366,9.217,20.59,20.59,20.59h466.702    c11.372,0,20.59-9.217,20.59-20.59C507.882,244.625,498.665,235.408,487.292,235.408z"
            fill="#ffffff"
            data-original="#000000"
            style=""
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M505.96,241.434L304.187,39.653c-8.044-8.037-21.07-8.037-29.114,0c-8.044,8.044-8.044,21.084,0,29.121l187.216,187.223    L275.073,443.221c-8.044,8.037-8.044,21.077,0,29.114c4.022,4.022,9.286,6.033,14.557,6.033s10.535-2.011,14.557-6.033    l201.773-201.78C514.004,262.511,514.004,249.47,505.96,241.434z"
            fill="#ffffff"
            data-original="#000000"
            style=""
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
    </g>
  </svg>
</ng-template>

<ng-template #iconDone>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:svgjs="http://svgjs.com/svgjs"
    version="1.1"
    width="19"
    height="21"
    x="0"
    y="0"
    viewBox="0 0 375.147 375.147"
    style="enable-background:new 0 0 19 21"
    xml:space="preserve"
  >
    <g>
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <polygon
            points="344.96,44.48 119.147,270.293 30.187,181.333 0,211.52 119.147,330.667 375.147,74.667   "
            fill="#ffffff"
            data-original="#000000"
            style=""
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
      <g xmlns="http://www.w3.org/2000/svg"></g>
    </g>
  </svg>
</ng-template>
